<div class="flex flex-col gap-4" [formGroup]="form">
  <mat-slide-toggle formControlName="isEnabled">
    Enable Verifone
  </mat-slide-toggle>

  <mat-slide-toggle formControlName="testModeEnabled">
    Test Mode
  </mat-slide-toggle>

  <div class="flex flex-col gap-1">
    <h3 class="!mb-0 !font-bold">Receipt printing</h3>
    <mat-radio-group
      formControlName="receiptPrintMethod"
      class="flex flex-col gap-1"
    >
      <mat-radio-button [value]="receiptPrintMethod.Terminal">
        Terminal prints the receipt
      </mat-radio-button>
      <mat-radio-button [value]="receiptPrintMethod.Principle">
        Principle prints the receipt
      </mat-radio-button>
    </mat-radio-group>
    <span class="mat-caption opacity-70">
      When the terminal prints, Verifone does not return the receipt to
      Principle, so it can't be reprinted from the invoice. Choose Principle to
      keep a copy against the payment (the terminal won't print).
    </span>
  </div>
</div>
